import { render } from "./LoginSsoPage.vue?vue&type=template&id=350b60c3&ts=true"
import script from "./LoginSsoPage.vue?vue&type=script&lang=ts"
export * from "./LoginSsoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__